<template>
  <router-view />
</template>

<script>
export default {
  name: "App",
};
</script>
<style>
/* 防止字体加载错误 */
@font-face {
  font-family: "FontAwesome";
  src: url("https://cdnjs.cloudflare.com/ajax/libs/font-awesome/4.7.0/fonts/fontawesome-webfont.woff2?v=4.7.0")
    format("woff2");
  font-display: swap;
}

.fa,
.fas,
.far,
.fal,
.fab {
  font-family: "FontAwesome" !important;
}
</style>

